<template>
    <div class="floor_map_main">
        <div class="floor_amap_box" ref="floorAmapBox"  :style="{height:height}"></div>
        <div class='device_list'>
            <deviceList :showDialog='showDialogList'  :is_loading ='loading' @closeDialog='closeDialogList'  @sortOnline='sort_online_list' @sortValve='sort_valve_list' :tableData ='listData' ></deviceList>
        </div>
    </div>
</template>


<script>
    import {mapState, mapMutations} from 'vuex'
    import deviceList from './device_list'
    import dataUrl from '../../../libs/js/interfaceAddress.js';
    export default {
        name: "floormapvue",
        props:{
            height:{
                type: String,
                default: () => {
                    return 0
                }
            },
            isStatus:{
                type: Boolean,
                default: () => {
                    return false
                }
            }
            //floorData:{
            //    type: Object,
            //    default: () => {
            //       return {}
            //    }
            //}
        },
        data(){
            return{
                amap_floor_map:null,
                showDialogList:false,
                floorMapData:[],  //楼层得数据
                listData:[], // 点击后的数据


                //地图配置
                mapCenter:[],
                mapSize:'',
                pitch: '',
                pitchEnable: true,
                rotateEnable:true ,
                rotation:'' ,
                zooms:null,
                //懒加载
                loading:false,
                sortFlag:true,
                valveSortFlag:true
            }
        },
        components:{
            deviceList
        },
        computed:{
            ...mapState(['onMessageArrived','map_other']),
        },
        mounted() {




          this.mapCenter = this.map_other[0].mapCenter;
          this.mapSize = this.map_other[0].mapSize;
          this.pitch = this.map_other[0].pitch;
          this.pitchEnable = this.map_other[0].pitchEnable;
          this.rotateEnable = this.map_other[0].rotateEnable;
          this.rotation = this.map_other[0].rotation;
          var arr = this.map_other[0].zooms.split(",");
          this.zooms = arr.map((item, index) => {
            return Number(item)
          })
          this.floor_map();
        },

        watch:{
            map_other:{
                handler(newVal,oldVal){

                  if(this.isStatus === false){
                        return false
                    }
                    newVal.forEach((item)=>{



                        this.mapCenter = item.mapCenter;
                        this.mapSize = item.mapSize;
                        this.pitch = item.pitch;
                        this.pitchEnable = item.pitchEnable;
                        this.rotateEnable = item.rotateEnable ;
                        this.rotation = item.rotation;
                        var arr = item.zooms.split(",");
                        this.zooms = arr.map((item,index)=>{
                            return Number(item)
                        })
                    });
                    this.floor_map();
                },
                deep:true
            },
            //floorData:{
            //    handler(newVal,oldVal){
            //        this.handleFloorData(newVal);
            //    },
            //    deep:true
            //}
        },
        methods:{
            ...mapMutations(['set_floorDeviceData']),
            handleFloorData(floor_data){
              console.log('set_devToday已经进来了-=-=-=-:-=-=--=-=-=-=-=-='+ JSON.stringify(floor_data));

              if(this.isStatus === false){
                    return false
                }
                this.floorMapData = Object.values(floor_data.devList);
                var  floorDeviceData =[];
                this.floorMapData.forEach((item,index)=>{
                    var count =parseInt(item.onlineDev)+parseInt(item.offlineDev);
                    this.$set(item,"count", count);
                    floorDeviceData.push(count);
                });
                //存储楼层数据用于图表设备占比分布
              console.log('floorDeviceData已经进来了-=-=-=-:-=-=--=-=-=-=-=-='+ JSON.stringify(floorDeviceData));

              this.set_floorDeviceData(floorDeviceData);
                //地图上定位楼层

              this.creatMarker();
            },
            floor_map() {
                let _this = this;
                this.amap_floor_map = new AMap.Map(this.$refs.floorAmapBox, {
                  mapStyle: 'amap://styles/038a3e00c8b9ffce298be9b7eb94cbd8',
                    // mapStyle: 'amap://styles/4159ad7d66c99d6465449055fa06f42a',
                    // center:[116.4071700000, 39.9046900000],
                    center:_this.mapCenter,
                    disableSocket: true,
                    viewMode: '3D',
                    resizeEnable: true,
                    buildingAnimation: true, //楼块出现是否带动画,
                    expandZoomRange: true,
                    features: ['bg', 'road', 'building', 'point'],
                    zoom:_this.mapSize,
                    rotateEnable:_this.rotateEnable,
                    pitchEnable:_this.pitchEnable, //是否允许设置俯仰角度
                    pitch:_this.pitch, //俯仰角度
                    rotation:_this.rotation, //旋转角度
                    zooms:_this.zooms,

                    // zoom:1000,
                    // pitch: 60,
                    // pitchEnable: true,
                    // rotateEnable: false,
                    // rotation: 40,
                    // zooms: [1,18.5]
                });
                //使用CSS默认样式定义地图上的鼠标样式
                 this.amap_floor_map.setDefaultCursor("pointer")
                // this.creatMarker();
                //绑定地图移动与缩放事件
                // this.amap_floor_map.on('moveend', this.logMapinfo);
                // this.amap_floor_map.on('zoomend', this.logMapinfo);

            },
            creatMarker(){
                let vue = this;
              console.log('creatMarker已经进来了-=-=-=-:-=-=--=-=-=-=-=-=');

              this.floorMapData.forEach((item,index)=>{
                    // var content = '<div> ' + item.name + '</div>';
                    // 创建一个 Icon
                console.log('creatMarker已经出来了-=-=-=-:-=-=--=-=-=-=-=-='+item+'=-=-=--=index=-=-='+index);

                var startIcon = new AMap.Icon({
                        // 图标尺寸
                        size: new AMap.Size(70, 88),
                        // 图标的取图地址
                        image: `https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/${index+1}.png`,
                        // 图标所用图片大小
                        imageSize: new AMap.Size(70, 88),
                        // 图标取图偏移量
                        imageOffset: new AMap.Pixel(0, -3)
                    });
                    var content = `<div class="marker-route marker-marker-bus-from"> ${item.count}套</div>`;

                    var marker = new AMap.Marker({
                        // content:content,
                        icon: startIcon,
                        position: [item.position[0],item.position[1]],
                        offset: new AMap.Pixel(-20, -50),
                        title:item.floorNo,
                        extData:item.floorNo
                    });
                    marker.setLabel({
                        offset: new AMap.Pixel(16, 35),  //设置文本标注偏移量
                        content: content, //设置文本标注内容
                        direction: 'top' //设置文本标注方位
                    });
                    // marker.setMap(this.amap_floor_map);
                    this.amap_floor_map.add(marker);


                    marker.on('click', function(e) {
                        var cur =JSON.parse(JSON.stringify(e.target.getExtData()));
                        vue.handleMarkerClick(cur);
                    });

                })


            },
            /**
             * 点击气泡，出现设备列表
             * n为点击的楼层
             * @param n
             */
            handleMarkerClick(index){
                this.showDialogList =true;
                this.$http.get(`${dataUrl.interfaceAddress.floorDeviceList}/${index}`, {}).then(res => {
                    this.loading = true;
                    if(res.data&&res.data.code ===1) {
                        this.loading =false;
                        this.listData  = res.data.data;
                        this.listData.forEach((item,index)=>{
                            this.$set(item,'id',index+1);
                        })
                    }

                }).catch((err) => {
                    console.log(err)
                    // reject(err)
                })

            },
            //关闭列表弹出框
            closeDialogList(){
                this.showDialogList =false;
            },
            sort_online_list(){
               var online_arr =[];
               var offline_arr =[];
               this.listData.forEach((item,index)=>{
                   if(item.status == 0){
                       offline_arr.push(item);
                   }
                   if(item.status == 1){
                       online_arr.push(item);
                   }
               });
               if(this.sortFlag){
                   this.listData=online_arr.concat(offline_arr);
                   this.sortFlag = false;
               }else {
                   this.listData = offline_arr.concat (online_arr);
                   this.sortFlag = true;
               }
            },
            sort_valve_list(){
                var open_valve =[];
                var close_valve =[];
                this.listData.forEach((item,index)=>{
                    if(item.valve == '开'){
                        open_valve.push(item);
                    }
                    if(item.valve == '关'){
                        close_valve.push(item);
                    }
                });
                if(this.valveSortFlag){
                    this.listData=open_valve.concat(close_valve);
                    this.valveSortFlag = false;
                }else {
                    this.listData = close_valve.concat (open_valve);
                    this.valveSortFlag = true;
                }

            }
        }

    }
</script>

<style scoped lang="less">
    /*////////////////////////////////////////////////////////////////////*/
    /*//                          _ooOoo_                               //*/
    /*//                         o8888888o                              //*/
    /*//                         88" . "88                              //*/
    /*//                         (| ^_^ |)                              //*/
    /*//                         O\  =  /O                              //*/
    /*//                      ____/`---'\____                           //*/
    /*//                    .'  \\|     |//  `.                         //*/
    /*//                   /  \\|||  :  |||//  \                        //*/
    /*//                  /  _||||| -:- |||||-  \                       //*/
    /*//                  |   | \\\  -  /// |   |                       //*/
    /*//                  | \_|  ''\---/''  |   |                       //*/
    /*//                  \  .-\__  `-`  ___/-. /                       //*/
    /*//                ___`. .'  /--.--\  `. . ___                     //*/
    /*//              ."" '<  `.___\_<|>_/___.'  >'"".                  //*/
    /*//            | | :  `- \`.;`\ _ /`;.`/ - ` : | |                 //*/
    /*//            \  \ `-.   \_ __\ /__ _/   .-` /  /                 //*/
    /*//      ========`-.____`-.___\_____/___.-`____.-'========         //*/
    /*//                           `=---='                              //*/
    /*//      ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^        //*/
    /*//         佛祖保佑       永无BUG     永不修改                     //*/
    /*////////////////////////////////////////////////////////////////////*/


</style>

<style lang="less">
    .floor_map_main{
        .amap-marker-label{
            border: none;
            background: transparent;
        }
        .amap-icon{
            cursor: pointer;
        }
    }

</style>



// WEBPACK FOOTER //
// src/page/main_content/floor_distribution/floor_map.vue